import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import LinkedInSettings from '@copilot/common/pages/settings/linkedin';
import { OrganizationMemberManager } from '@copilot/data';
import { useFetch } from '@copilot/common/hooks/common';
import { OrganizationMemberActions } from '@copilot/common/store/actions/organizationMember';
import { OrganizationMemberSelectors } from '@copilot/common/store/selectors/organizationMember';
import BaseModal, { BaseModalProps } from '../base';

interface LinkedinSyncProps extends BaseModalProps {
	user: { id: string; isLinkedInLoggedIn: boolean };
}

const LinkedinSync: React.FC<LinkedinSyncProps> = (props) => {
	const { user, ...modalProps } = props;
	const [, fetchOrganizationMember] = useFetch(
		(omid: string) => OrganizationMemberManager.getMember(omid),
		OrganizationMemberActions.loadOrganizationMember,
		(r) => r
	);
	const member = useSelector((state) => OrganizationMemberSelectors.getOrgMember(state, user.id));

	useEffect(() => {
		fetchOrganizationMember(user.id);
	}, [user?.id]);

	return (
		<BaseModal {...modalProps}>
			{member && <LinkedInSettings user={member} isLoggedIn={member?.isLinkedInLoggedIn} />}
		</BaseModal>
	);
};

export default LinkedinSync;
